// REACT
import React from "react";

// MATERIAL-UI
import { Grid, TextField } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import SearchIcon from "@mui/icons-material/Search";

// COMPONENTS
import DropdownList from "./DropdownList";

// ASSESTS
import { SelectCurrencyStyles } from "../common/styles/SelectCurrency.styles";
import { DropdownBodyProps } from "../common/types/dropdownTypes";
import Instructions from "../header/Instructions";
import { useLocation } from "react-router-dom";
import {
  CloseButton,
  Header,
  HeaderAndSearch,
  SearchBar,
  SearchBarIcon,
  SearchBarWrapper,
} from "src/components/common/crypto-selection-modalV2/CryptoSelectionModalV2";
import CloseIcon from "@mui/icons-material/Close";
import MagnifyingGlass from "src/icons/MagnifyingGlass";

const errorMessage = "Only alphanumerical letters allowed";
const placeholder = "Search";

const initialFilter = [
  {
    change: 0,
    available: 0,
    price: 0,
    value: 0,
    pendingValue: 0,
    total: 0,
    openTargets: 0,
    reserved: 0,
    currency: {
      code: "",
      type: "",
      name: "",
      formatName: "",
      id: "",
      networkName: "",
      logoUrl: "",
      inactive: false,
      depositable: false,
      memo: false,
    },
  },
];

const DropdownBody = (props: DropdownBodyProps) => {
  const classes = SelectCurrencyStyles();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const location = useLocation();
  const [error, setError] = React.useState<boolean>(false);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [filter, setFilter] = React.useState<any>(initialFilter);

  const loop = (all: any) => {
    let formattedData = [];

    for (let index in all) {
      let obj = {
        change: 0,
        available: 0,
        price: 0,
        value: 0,
        pendingValue: 0,
        total: 0,
        openTargets: 0,
        reserved: 0,
        code: "",
        type: "",
        name: "",
        formatName: "",
        id: "",
        networkName: "",
        logoUrl: "",
        inactive: false,
        depositable: false,
        memo: false,
      };
      obj["change"] = all[index].change;
      obj["available"] = all[index].available;
      obj["price"] = all[index].price;
      obj["value"] = all[index].value;
      obj["total"] = all[index].code;
      obj["code"] = all[index].code;
      obj["formatName"] = all[index].formatName;
      obj["logoUrl"] = all[index]?.logoUrl;
      obj["depositable"] = all[index].depositable;
      obj["memo"] = all[index].memo;
      obj["name"] = all[index].name.toLowerCase();
      formattedData.push(obj);
    }

    return formattedData;
  };

  const handleFilter = (all: any) => {
    if (searchTerm.length <= 0) {
      setFilter(all);
      return;
    }
    const formattedData = loop(all);

    let newFilter: any = [];

    for (let i = 0; i < formattedData.length; i++) {
      if (formattedData[i].name.includes(searchTerm.toLowerCase())) {
        newFilter = [...newFilter, formattedData[i]];
      }
    }
    setFilter(newFilter);
  };

  const handleOnChange = (e: any) => {
    setSearchTerm(e.target.value);
  };

  React.useEffect(() => {
    // GET TRENDING DATA ON INITIAL LOAD
    if (searchTerm.length <= 0) {
      setError(false);
    }
    handleFilter(props.data);
  }, [searchTerm]);

  React.useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get("code");
    if (code) {
      setSearchTerm(code);
    }
  }, []);

  return (
    <Grid container className={classes.searchbarContainer}>
      <Grid
        item
        xs
        style={{
          width: "100%",
          padding: isMobile ? "0px 25px 20px 20px" : "0px 25px 0px 20px",
        }}>
        {isMobile ? (
          //Have to duplicate code to change autofocus as isMobile doesn not become active until 2nd render
          <TextField
            autoFocus
            variant="outlined"
            placeholder={placeholder}
            className={classes.searchbar}
            value={searchTerm}
            onChange={handleOnChange}
            error={!!error}
            type="text"
            InputProps={{
              startAdornment: (
                <SearchIcon
                  fontSize="medium"
                  color="disabled"
                  classes={{ root: classes.searchbarIcon }}
                />
              ),
            }}
          />
        ) : (
          <HeaderAndSearch>
            {/* searchbar */}
            <SearchBarWrapper>
              <SearchBar
                autoFocus
                placeholder="Search"
                onChange={handleOnChange}
                value={searchTerm}
              />
              <SearchBarIcon>
                <MagnifyingGlass />
              </SearchBarIcon>
            </SearchBarWrapper>
          </HeaderAndSearch>
        )}
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          {/* ERROR */}
          {error && (
            <div className={classes.error}>
              <p>{errorMessage}</p>
            </div>
          )}

          <Grid item container>
            <Grid item sx={{ marginLeft: "24px", marginBottom: "10px" }}>
              <Instructions options="primary" />
            </Grid>
            <DropdownList
              data={searchTerm.length <= 0 ? props.data : filter}
              onClick={props.config.onClick}
              searchTerm={searchTerm.length}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DropdownBody;
